import PropTypes from 'prop-types';
import { Box, Typography } from '@mui/material';

export default function FormSectionHeader({ title, description }) {
  return (
    <Box component="header" sx={{ mb: 2 }}>
      <Typography variant="subtitle1" component="h3" sx={{ fontWeight: 600 }}>
        {title}
      </Typography>
      {description && (
        <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5, lineHeight: 1.65, maxWidth: 640 }}>
          {description}
        </Typography>
      )}
    </Box>
  );
}

FormSectionHeader.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
};
